import '../GaEvents';
import '../ReactSelect.util';
export var getCareDetailSelectOptions = function (detailDescriptor, detailLabel) {
    return Object.values(detailDescriptor).map(function (detail) { return ({ value: detail, label: detailLabel[detail] }); });
};
